import React from "react";

import styled from "@mui/material/styles/styled";

import Stack, { StackProps } from "../Stack";

export interface IconBackgroundProps extends StackProps {
  height: number;
  borderRadius?: React.CSSProperties["borderRadius"];
  padding?: number; // padding in pixels around the icon
}

/** Simple background for an SVG icon */
const IconBackground = styled(
  ({ height: _h, padding: _p, ...props }: IconBackgroundProps) => (
    <Stack variant="center" {...props} />
  )
)(({ borderRadius, height, padding }) => ({
  height: `${height}px`,
  width: `${height}px`,
  borderRadius: borderRadius ?? "50%",
  flexShrink: 0,

  "& svg": {
    height: `${(height * 2) / 3 - (padding ?? 0) * 2}px`,
    width: `${(height * 2) / 3 - (padding ?? 0) * 2}px`,
  },
}));

export default IconBackground;
